require('./bootstrap');

//NAV MENU RESPONSIVE
$((function() {
    var e = $("body"),
        t = $(".navbar"),
        i = $(".navbar-collapse");
    e.append('<div class="side-menu-overlay"></div>');
    var r = $(".side-menu-overlay");
    e.append('<div id="side-menu"></div>');
    var o = $("#side-menu");
    o.append('<button class="close"><span aria-hidden="true">×</span></button>');
    var n = o.find(".close");
    o.append('<div class="contents"></div>');
    var a = o.find(".contents");

    function s() {
        e.removeClass("side-menu-visible"),
            r.fadeOut(),
            setTimeout((function() {
                o.hide(),
                    e.removeClass("overflow-hidden")
            }), 400)
    }
    t.hasClass("better-bootstrap-nav-left") && o.addClass("side-menu-left"),
        i.on("show.bs.collapse", (function(t) {
            t.preventDefault();
            var i = $(this).html();
            a.html(i),
                e.addClass("overflow-hidden"),
                o.show(),
                setTimeout((function() {
                    e.addClass("side-menu-visible"),
                        r.fadeIn()
                }), 50)
        })),
        n.on("click", (function(e) {
            e.preventDefault(),
                s()
        })),
        r.on("click", (function(e) {
            s()
        })),
        $(window).resize((function() {
            !i.is(":visible") && e.hasClass("side-menu-visible") ? (o.show(),
                r.show()) : (o.hide(),
                r.hide())
        }))


}));


function getFieldType(e) {
    var type = 'months';
    if (e.hasClass('amount')) {
        type = 'amount';
    } else if (e.hasClass('deposit')) {
        type = 'deposit';
    }

    return type;
}
$('#acceptcookies').on("click", function() {
    $.ajax({
        type: 'GET', //THIS NEEDS TO BE GET
        url: 'set/cookies',
        success: function(data) {
            console.log(data);
            if (data.success) {
                $('.cookiealert').hide();
            }
        },
        error: function() {
            console.log(data);
        }
    });
});
//CALCULATOR
$('input.calculator[type=range]').on('change', function() {

    var value = $(this).val();
    var type = getFieldType($(this));
    // alert(value+'tipo='+type);
    if (type == 'amount' || type == 'deposit') {
        value = setMoneda(value, "slider");
        $('input.' + type + '[type=text]').val(value);
    } else {
        value = value + ' months';
        $('output.' + type).val(value);
    }

    $('input.' + type + '[type=hidden]').val($(this).val());
    divsManagement("none");
});

$('input.calculator[type=text]').on('change', function() {
    var value = $(this).val();
    var type = getFieldType($(this));

    if (type == 'amount' || type == 'deposit') {
        value = value.toString().replace(/\£|\,/g, "");
    } else {
        value = value.toString().replace(/ months/g, "");
    }

    $('input.' + type + '[type=hidden]').val(value);
    $('input.' + type + '[type=range]').val(value);
    divsManagement("none");
});

function onchange_text(e, t, i) {
    e = "hidden_amount" == i || "hidden_deposit" == i ? e.toString().replace(/\£|\,/g, "") : e.toString().replace(/ months/g, ""),
        document.getElementById(i).value = e,
        document.getElementById(t).value = e,
        divsManagement("none")
}